import React from "react";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import AdminSettingsPage from "pages/AdminView/AdminSettingsPage/AdminSettingsPage";
import ClientSettingsPage from "pages/ClientView/ClientSettingsPage/ClientSettingsPage";
import RecruiterSettingsPage from "pages/RecruitersView/RecruiterSettingsPage/RecruiterSettingsPage";
import ErrorPage from "pages/ErrorPage/ErrorPage";

export default function SettingsSwitch() {
  const appContext = useAppContext();
  const { account } = appContext;
  const { accountType } = account;

  if (accountType.type === ACCOUNT_TYPES.ADMIN.type) {
    return <AdminSettingsPage />;
  } else if (accountType.type === ACCOUNT_TYPES.RECRUITER.type) {
    return <RecruiterSettingsPage />;
  } else if (accountType.type === ACCOUNT_TYPES.EMPLOYER_PRIVATE.type) {
    return <ClientSettingsPage />;
  } else {
    return <ErrorPage />;
  }
}
